import { MaterialTextInput, MaterialTextInputProps } from '@jfs/ui-new';


interface AdminPortalTextInputProps extends MaterialTextInputProps {
    textType?: 'nameWithSpace' | 'captialize' | 'numOnly'
}

export const AdminPortalTextInput = (props: AdminPortalTextInputProps) => {
    return (
        <MaterialTextInput

            color={'BRAND_COLOR_GRAY_1'}
            fontSize={16}
            {...props}
            onChange={(text: string) => {
                if (props.textType === 'nameWithSpace') {
                    if (text.trim().length === 0) {
                        text = text.trim()
                    } else if (
                        ['  ', '..', "''", ".'", '. ', "' ", "'.", ' .', " '"].includes(text.slice(-2)) ||
                        !text.match(/^[a-zA-Z]+(\s{0,1}[a-zA-Z'. ])*$/)
                    ) {
                        text = text.slice(0, text.length - 1)
                    }
                } else if (props.textType === 'captialize') {
                    text = text.toUpperCase()
                } else if (props.textType === 'numOnly' && !/^\d+$/.test(text)) {
                    text = text.slice(0, text.length - 1)
                }
                props.onChange?.call(this, text)
            }}
        />
    );
}
